import axios from "axios";
import { getAuth } from "firebase/auth";
import { getAuthCentral } from "../../config/FirebaseConfig";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import { checkDB } from "../../models/DataFunctions.js";
import addLogDocument from "../addLogDocument.js"; // Custom log function

const uploadBookShelf = async (uploadedList, org_id, type, token, prefix) => {
  try {
    for (const up of uploadedList) {
      const fileUrl = up.url;

      // Download the file from the provided URL using Axios
      const fileResponse = await axios.get(fileUrl, {
        responseType: "arraybuffer",
      });

      if (fileResponse.status === 200) {
        const fileBytes = new Uint8Array(fileResponse.data);
        const fileName = up.name;

        const url = `${prefix}organisations/${org_id}/bookshelf/${type}`;

        const formData = new FormData();
        // Append the file to formData with explicit PDF MIME type
        formData.append(
          "file",
          new Blob([fileBytes], { type: "application/pdf" }),
          fileName
        );

        const headers = {
          Authorization: `Bearer ${token}`,
          // Let Axios handle Content-Type for FormData
        };
        let start = new Date();

        // Upload the file using Axios
        const response = await axios.post(url, formData, { headers });

        // Handle Firebase authentication
        const auth = getAuthCentral();
        const currentUser = auth.currentUser;

        if (!currentUser) {
          console.error("User is not authenticated");
          return;
        }

        const db = getFirestore();
        const userRef = doc(db, "user", currentUser.uid);
        const userSnapshot = await getDoc(checkDB(userRef));

        if (!userSnapshot.exists()) {
          console.error("User document not found");
          return;
        }

        org_id = userSnapshot.get("org_id");
        let end = new Date();
        let elapsed = end - start;
        // Log the document upload
        await addLogDocument(
          url,
          prefix,
          userRef,
          org_id,
          response.status.toString(),
          null,
          "", // Assuming empty for additional data
          "", // request body as string
          response.data,
          "POST",
          elapsed
        );

        if (response.status === 200) {
        } else {
          console.error(
            `Error response for file ${fileName}: ${response.status}`
          );
        }
      } else {
        console.error(
          `Failed to download file from URL: ${fileResponse.status}`
        );
      }
    }
  } catch (error) {
    console.error("Error processing files:", error);
  }
};

export default uploadBookShelf;
